import { Colors, Img, Lightning, Utils } from '@lightningjs/sdk'
import { cleanHtml, formatDate, formatTimeHoursOrMinutes, daysLeft } from '../../lib/AppHelpers'

export default class EpisodeItem extends Lightning.Component {
  static _template() {
    return {
      w: 800,
      h: 195,
      CoverWrapper: {
        w: 150,
        h: 150,
        pivotX: 0,
        pivotY: 0,
        CoverImageWrapper: {
          w: 150,
          h: 150,
          shader: { radius: 5, type: Lightning.shaders.RoundedRectangle },
          CoverBG: { w: 150, h: 150, src: '' },
          Cover: { w: 150, h: 150 },
        },
        CoverBorder: {
          w: 150,
          h: 150,
          rect: true,
          shader: {
            radius: 5,
            stroke: 3,
            strokeColor: Colors('border')
              .alpha(0)
              .get(),
            fill: false,
            fillColor: 0x00000000,
            type: Lightning.shaders.RoundedRectangle,
          },
        },
      },
      InfoWrapper: {
        w: 630,
        x: 169,
        y: 0,
        Title: {
          w: 532,
          color: Colors('white').get(),
          text: {
            text: this.bindProp('title'),
            fontSize: 28,
            lineHeight: 36,
            fontFace: 'OpenSansRegular',
            wordWrapWidth: 532,
            maxLines: 2,
            textOverflow: 'ellipsis',
          },
        },
        DescrText: {
          w: 532,
          color: Colors('white').get(),
          text: {
            text: this.bindProp('descrText'),
            fontSize: 22,
            fontFace: 'OpenSansRegular',
            lineHeight: 32,
            wordWrapWidth: 532,
            maxLines: 1,
            textOverflow: 'ellipsis',
          },
        },
        DateLength: {
          w: 800,
          color: Colors('white').get(),
          text: {
            text: this.bindProp('dateLength'),
            lineHeight: 35,
            fontSize: 22,
            fontFace: 'OpenSansRegular',
          },
        },
      },
      BottomLine: {
        w: 800,
        h: 2,
        y: 190,
        rect: true,
        color: Colors('white').get(),
      },
    }
  }

  set item(itm) {
    this._item = itm
  }

  get item() {
    return this._item
  }
  set bgImage(v) {
    this._itemBg = v
  }

  _init() {
    this._expanded = false

    this.tag('Cover').on('txError', () => {
      this.tag('Cover').patch({
        src: Utils.asset('images/covers/ArtistPlaceHolder.png'),
      })
    })
    this.tag('Title').on('txLoaded', () => {
      this.tag('DescrText').y = this.tag('Title').y + this.tag('Title').finalH + 8
    })
    this.tag('DescrText').on('txLoaded', () => {
      this.tag('DateLength').y = this.tag('DescrText').y + this.tag('DescrText').finalH
    })
  }

  _firstActive() {
    this._update()
  }

  set albumImage(img) {
    this._albumImage = img
  }

  _update() {
    let title = this._itemBg
        ? formatDate(new Date(this._item.startDate), {
            weekday: 'long',
            day: 'numeric',
            month: 'long',
          })
        : this._item.title,
      descrText = cleanHtml(this._item.description),
      until = new Date(this._item.availableUntil ? this._item.availableUntil : this._item.pubDate)

    let dateLength = ''
    if (this._item && this._item.duration) {
      const dur = this._item.duration.split(':')
      until = this._itemBg
        ? `${daysLeft(until)} days left`
        : formatDate(until, {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
          })

      const seconds = dur[0] * 3600 + dur[1] * 60 + +dur[2]
      dateLength = this._itemBg
        ? `${formatTimeHoursOrMinutes(seconds)}  ${until}`
        : `${until}  ${formatTimeHoursOrMinutes(seconds)}`
    }
    let coverImage = ''
    if (this._item && this._item.imageUrl) {
      coverImage = this._item.imageUrl
    } else if (this._albumImage) {
      coverImage = this._albumImage
    }
    this.patch({
      CoverWrapper: {
        CoverImageWrapper: {
          CoverBG: {
            texture: Img(
              this._itemBg ? this._itemBg : Utils.asset('images/covers/ImagePlaceHolder.jpg')
            ).cover(150 / 2, 150 / 2),
          },
          Cover: { texture: Img(coverImage).cover(150 / 2, 150 / 2) },
        },
      },
      title,
      descrText,
      dateLength,
    })
  }

  _showLargeSmall(bool) {
    this._expanded = bool

    const itemWidth = bool === true ? 800 : 800
    const itemHeight = bool === true ? 320 : 195
    const scale = bool === true ? 1.7 : 1
    // const sha = bool === true ? 0.6 : 0.3;
    const coverBorderStroke = bool === true ? 1 : 0
    const infoWrapperWidth = bool === true ? 565 : 630
    const infoWrapperX = bool === true ? 285 : 169
    const descriptionMaxLines = bool === true ? 2 : 1
    const bottomLineHeight = bool === true ? 3 : 2
    const bottomLineY = bool === true ? 315 : 190
    const textFontFace = bool === true ? 'OpenSansBold' : 'OpenSansRegular'

    this.patch({
      w: itemWidth,
      h: itemHeight,
      CoverWrapper: {
        smooth: { scale: [scale, EpisodeItem.TRANSITION] },
        CoverBorder: {
          smooth: { 'shader.strokeColor': [coverBorderStroke, EpisodeItem.TRANSITION4] },
        },
      },
      InfoWrapper: {
        smooth: {
          w: [infoWrapperWidth, EpisodeItem.TRANSITION],
          x: [infoWrapperX, EpisodeItem.TRANSITION],
        },
        Title: {
          text: {
            fontFace: textFontFace,
          },
        },
        DescrText: {
          text: { maxLines: descriptionMaxLines },
        },
      },
      BottomLine: {
        smooth: {
          w: [itemWidth, EpisodeItem.TRANSITION],
          h: [bottomLineHeight, EpisodeItem.TRANSITION],
          y: [bottomLineY, EpisodeItem.TRANSITION],
        },
      },
    })
  }

  _focus() {
    this._showLargeSmall(true)
    this.tag('CoverBorder').patch({
      smooth: {
        'shader.strokeColor': [
          Colors('border')
            .alpha(1)
            .get(),
          { duration: 0.4, timingFunction: 'ease-in' },
        ],
      },
    })
  }

  _unfocus() {
    this._showLargeSmall(false)
    this.tag('CoverBorder').patch({
      smooth: {
        'shader.strokeColor': [
          Colors('border')
            .alpha(0)
            .get(),
          { duration: 0.4, timingFunction: 'ease-in' },
        ],
      },
    })
  }

  get cellSizes() {
    return this.sizes
  }
}
EpisodeItem.TRANSITION = { duration: 0.3, delay: 0, timingFunction: 'ease-in' }
EpisodeItem.TRANSITION4 = { duration: 0.4, timingFunction: 'ease-in' }
